import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setTasklists: (state: IRootState, action: PayloadAction<IRootState['tasklists']>) => ({
    ...state,
    tasklists: action.payload,
  }),
  setSubmissions: (state: IRootState, action: PayloadAction<IRootState['submissions']>) => ({
    ...state,
    submissions: action.payload,
  }),
  setDailySubmissions: (state: IRootState, action: PayloadAction<IRootState['dailySubmissions']>) => ({
    ...state,
    dailySubmissions: action.payload,
  }),
  setSelectedTasklist: (state: IRootState, action: PayloadAction<IRootState['selectedTasklist']>) => ({
    ...state,
    selectedTasklist: action.payload,
  }),
  setSelectedSubmission: (state: IRootState, action: PayloadAction<IRootState['selectedSubmission']>) => ({
    ...state,
    selectedSubmission: action.payload,
  }),
  setSelectedTasklistForAction: (state: IRootState, action: PayloadAction<IRootState['selectedTasklistForAction']>) => ({
    ...state,
    selectedTasklistForAction: action.payload,
  }),
  setIsOpenDeleteDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteDialog']>) => ({
    ...state,
    isOpenDeleteDialog: action.payload,
  }),
  setSubmittedTasklists: (state: IRootState, action: PayloadAction<IRootState['submittedTasklists']>) => ({
    ...state,
    submittedTasklists: action.payload,
  }),
  setFormattedSubmissions: (state: IRootState, action: PayloadAction<IRootState['formattedSubmissions']>) => ({
    ...state,
    formattedSubmissions: action.payload,
  }),
  setSelectedDailySubmission: (state: IRootState, action: PayloadAction<IRootState['selectedDailySubmission']>) => ({
    ...state,
    selectedDailySubmission: action.payload,
  }),
  setSelectedTasklistToSubmit: (state: IRootState, action: PayloadAction<IRootState['selectedTasklistToSubmit']>) => ({
    ...state,
    selectedTasklistToSubmit: action.payload,
  }),
  setSubmissionsTab: (state: IRootState, action: PayloadAction<IRootState['tab']>) => ({
    ...state,
    tab: action.payload,
  }),
  setIsOpenAllTasklistsNav: (state: IRootState, action: PayloadAction<IRootState['isOpenAllTasklistsNav']>) => ({
    ...state,
    isOpenAllTasklistsNav: action.payload,
  }),
  setIsOpenAllSubmissionsNav: (state: IRootState, action: PayloadAction<IRootState['isOpenAllTasklistsNav']>) => ({
    ...state,
    isOpenAllSubmissionsNav: action.payload,
  }),
  setTasklistSelectedLocationId: (state: IRootState, action: PayloadAction<IRootState['tasklistSelectedLocationId']>) => ({
    ...state,
    tasklistSelectedLocationId: action.payload,
  }),
};

export {
  reducers,
};
